  <button *ngFor="let item of allAvailableMonths" (click)="itemClicked(item)" class="diary-calendar-months">
    <span *ngIf="hasEvents(item.value)" class="diary-calendar-has-events"></span>
    <span class="diary-calendar-months-name">{{item.text}}</span>
  </button>
